export default __webpack_public_path__ + "static/media/ponentes__ALEJANDRO DE KEIJSER TORRES.6309856c.jpg";